import axios from '@/axios/axios';
import { config } from '@/axios/config';

export const post = (url, data, options = {}) => {
    return axios({
        url,
        method: 'post',
        headers: {
            ...(options.headers || {}),
            Authorization: config.Authorization,
        },
        data,
    });
};


export const get = (url, options = {}) => {
    return axios({
        url,
        method: 'get',
        headers: {
            ...(options.headers || {}),
            Authorization: config.Authorization,
        },
        data: options.data || undefined,
    });
};

